import React from 'react';
import i18n from 'i18next';
import { css } from '@emotion/core';
import Typography from '@material-ui/core/Typography';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { PointSystemPoints } from 'client/components/dialogVerification/dialogDeductPoint/DialogDeductPoint';

import Popup from 'client/components/Popup';

export default function DialogDeductSuccess({ open, transactionWithdrawQuantity }) {
    return (
        <Popup isOpen={open} css={dialogStyle}>
            <div css={modalContentStyle}>
                <CheckCircleIcon css={iconStyle} />
                <div css={descStyle}>
                    <Typography variant="h6">{i18n.t('label.deduct')}</Typography>
                    <PointSystemPoints pointCount={transactionWithdrawQuantity} pointSize={20} />
                </div>
                <Typography variant="h6">{i18n.t('label.passcode.verify.success')}</Typography>
            </div>
        </Popup>
    );
}

const dialogStyle = css`
    max-width: 280px;
`;

const modalContentStyle = css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 240px;
    > svg {
        margin-bottom: 25px;
    }
`;

const iconStyle = css`
    font-size: 85px;
    color: #00b022;
`;

const descStyle = css`
    display: flex;
    justify-content: center;
    align-items: center;
`;
